import React from 'react'

const CreditsHeader = () => {
	return (
			<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'flex-start'
					}}
			>
				<h2
						style={{
							fontSize: 18,
							fontWeight: '600'
						}}
				>
					Credits
				</h2 >
			</div >
	)
}

export default CreditsHeader

